/**
 * The organisation the app is currently showing.
 *
 * Its own file so SelectedTenantContext.tsx exports only components, which is
 * what react-refresh asks for and what ToastContext/useToast already do here.
 *
 * Returns an empty answer rather than throwing when no provider is above it.
 * A screen outside the shell — a test rendering one page, a public route — asks
 * the same question and should get "no organisation" rather than an exception,
 * the same way RequirePage treats a missing outlet context as no pages held.
 */

import { useContext } from 'react';
import {
  SelectedTenantContext,
  type SelectedTenantValue,
} from './selectedTenant';

const NONE: SelectedTenantValue = {
  tenants: [],
  selected: null,
  selectTenant: () => {},
};

export function useSelectedTenant(): SelectedTenantValue {
  return useContext(SelectedTenantContext) ?? NONE;
}
